var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkOut = function SvgLinkOut(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-182.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,12.1c0,0.3-0.3,0.6-0.6,0.6H1.9c-0.3,0-0.6-0.3-0.6-0.6V1.9c0-0.3,0.3-0.6,0.6-0.6h3V0h-3 C0.8,0,0,0.8,0,1.9v10.3c0,1,0.8,1.9,1.9,1.9h10.3c1,0,1.9-0.8,1.9-1.9v-3h-1.2V12.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.1,0 8.1,1.2 11.9,1.2 5,8.1 5.9,9 12.8,2.1 12.8,5.9 14,5.9 14,0"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link_out.7650035b.svg";
export { ForwardRef as ReactComponent };